/** Always binds the receipt screen to the selected session, including sessions
 * whose Stripe page is a refund of the unused pre-authorization hold. */
export const sessionReceiptPath = (sessionId: string) => `/sessions/${encodeURIComponent(sessionId)}/receipt`;
